export default "__VITE_ASSET__CRX0dcLA__"